import { render, staticRenderFns } from "./zona-regali-med.vue?vue&type=template&id=9255c288"
import script from "./zona-regali-med.vue?vue&type=script&lang=js"
export * from "./zona-regali-med.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports